import { LazyPageLoading } from '@components/lazy-page-loading'
import { lazy, Suspense } from 'react'

const Document = lazy(() =>
  import('@pages/document/document').then((module) => ({
    default: module.Document,
  })),
)

export const DocumentRoute = () => (
  <Suspense fallback={<LazyPageLoading />}>
    <Document />
  </Suspense>
)
